
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nyheter",
      function () {
        return require("private-next-pages/nyheter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nyheter"])
      });
    }
  